import { CircularProgress, Grid } from '@material-ui/core';
import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import advanced from "dayjs/plugin/advancedFormat";
require('dayjs/locale/ru')
import moment from 'moment-timezone';
import React from 'react';
import DayPicker from 'react-day-picker';
import Breadcrumbs from '../../elements/Breadcrumbs';
import {
  Cell, Cells, CellsContainer, CellsTitle, MainContainer, ScheduleContainer, AppointmentsList, AppointmentLabel, AppointmentTitle, InfoText, NextBtn, CalendarLoader, WarningMessage,
} from './Schedule.style';
import AppointmentInfoTab from '../AppointmentInfoTab/AppointmentInfoTab';


dayjs.locale('ru');

dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.extend(advanced);

const timeZoneOffset = Number(localStorage.getItem('timeZoneOffset'));

const MONTHS = [
  'Январь',
  'Февраль',
  'Март',
  'Апрель',
  'Май',
  'Июнь',
  'Июль',
  'Август',
  'Сентябрь',
  'Октябрь',
  'Ноябрь',
  'Декабрь',
];
const WEEKDAYS_LONG = [
  'Понедельник',
  'Вторник',
  'Среда',
  'Четверг',
  'Пятница',
  'Суббота',
  'Воскресенье',
];
const WEEKDAYS_SHORT = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];

const Schedule = ({
  isLoading,
  isCalendarLoading,
  doctor,

  sheduleList,
  selectedDay,
  handleClickDay,
  onMonthChange,

  cellsList,
  selectedCell,
  handleClickCell,

  logs,

  handleClickAppointments,

  payType,
}) => {

  const modifiers = {
    // disabled: { daysOfWeek: [5, 6] },
    highlighted: new Date(selectedDay),
    myAppointments: (day) => {
      return sheduleList.find((item) =>
        new Date(day).getDate() === new Date(item.date).getDate()
        && new Date(day).getMonth() === new Date(item.date).getMonth()
        && item.hasLogs
      )
    },
  };

  const selectedDays = sheduleList.map((item) => {
    if (item.hasAvailableCells) {
      return new Date(item.date);
    }
  })


  return (
    <>
      <AppointmentInfoTab text={`Прием иногородних пациентов ведется по записи: каб. №1 пн. и чт.; каб. №2 вт. и чт., каб.№4 вт. и чт., каб.№5 вт. и чт.`}/>
      <Breadcrumbs pathArr={[{ label: 'Запись на прием' }, { label: doctor }]} payType={payType} />
      <MainContainer>
        <Grid container direction="row">
          <Grid item xs={12} md={6}>
            <ScheduleContainer>
              {isCalendarLoading && <CalendarLoader><CircularProgress size={40} /></CalendarLoader>}
              <DayPicker
                locale='ru'
                firstDayOfWeek={1}
                months={MONTHS}
                weekdaysLong={WEEKDAYS_LONG}
                weekdaysShort={WEEKDAYS_SHORT}
                modifiers={modifiers}
                selectedDays={selectedDays}
                showOutsideDays={true}
                onDayClick={(e) => handleClickDay(e)}
                onMonthChange={onMonthChange}
              />
            </ScheduleContainer>
            {logs.length > 0 &&
              <AppointmentsList>
                <CellsTitle>Приемы на {dayjs(selectedDay).utc().utcOffset(timeZoneOffset || 10).format("DD.MM.YYYY")}</CellsTitle>
                {logs.map((item) =>
                  <Grid container direction="row" key={item.description + item.date}>
                    <Grid item xs={4} md={2}>
                      <AppointmentLabel>Время</AppointmentLabel>
                      <AppointmentTitle>{dayjs(item.date).utc().utcOffset(timeZoneOffset || 10).format("HH:mm")}</AppointmentTitle>
                    </Grid>
                    <Grid item xs={8} md={10}>
                      <AppointmentLabel>Прием</AppointmentLabel>
                      <AppointmentTitle>{item.description}</AppointmentTitle>
                    </Grid>
                  </Grid>
                )}
              </AppointmentsList>
            }
          </Grid>
          <Grid item xs={12} md={6}>
            <CellsContainer>
              {sheduleList.length && payType && !sheduleList.find((item) => {
                if (item.hasAvailableCells) {
                  return new Date(item.date);
                }
              }) ? <>
                <WarningMessage>Запись онлайн на прием за наличный расчет на этот месяц временно не доступна. Телефон отдела платных услуг <a href="tel:84212474241">47-42-41</a></WarningMessage>
              </>
                : <>
                  <CellsTitle>Время приема</CellsTitle>
                  {isLoading
                    ? <CircularProgress size={40} />
                    : <Cells>
                      <Grid container direction="row">
                        {cellsList.length
                          ? cellsList.map((item) =>
                            <Grid item xs={6} sm={3} md={4} lg={3} key={item.scheduleId}>
                              <Cell
                                onClick={() => handleClickCell(item)}
                                isActive={selectedCell && item.scheduleId === selectedCell.scheduleId}
                              >
                                {dayjs(item.time).utc().utcOffset(timeZoneOffset || 10).format('HH:mm')}
                              </Cell>
                            </Grid>
                          )
                          : <InfoText>{new Date(selectedDay) > new Date() ? 'Нет свободного времени' : 'Время для записи истекло'}</InfoText>
                        }
                      </Grid>
                    </Cells>
                  }
                </>}
              {/* <Button
                                variant="contained"
                                color="primary"
                                disabled={!selectedCell}
                                onClick={handleClickAppointments}
                            >
                                ДАЛЕЕ
                            </Button> */}
            </CellsContainer>
          </Grid>


        </Grid>
      </MainContainer>
      <NextBtn onClick={handleClickAppointments}></NextBtn>
    </>
  )
}

export default Schedule;
